import * as React from "react";
import type { SVGProps } from "react";
const SvgSectorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="sector_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="m635.733 388.267 60.459-213.334a386.219 386.219 0 0 1 152.875 152.918l-213.248 60.416zm314.454-44.715A470.784 470.784 0 0 0 680.448 73.813c-21.973-8.448-45.653 4.907-52.053 27.563l-95.574 337.11a42.667 42.667 0 0 0 52.694 52.693l337.109-95.574c22.699-6.4 36.01-30.08 27.563-52.053zM170.667 512A341.333 341.333 0 0 1 512 170.667a42.667 42.667 0 1 0 0-85.334C276.352 85.333 85.333 276.352 85.333 512S276.352 938.667 512 938.667 938.667 747.648 938.667 512a42.667 42.667 0 1 0-85.334 0 341.333 341.333 0 1 1-682.666 0z"
    />
  </svg>
);
export default SvgSectorIcon;
